<template>
  <div>
    <div class="mb-1">
      <div><label><input v-model="taskData.type_id" value="-1" type="radio"> запись в черный список без условий</label>
      </div>
      <div><label><input v-model="taskData.type_id" value="-2" type="radio"> запись в черный список c условиями</label>
      </div>
    </div>
    <div v-if="+taskData.type_id === -2">
      <div class="alert alert-info">
        <p>Используйте условия сверху, для добавления в черный список</p>
      </div>
      <!--      <button class="btn btn-default" @click="addOptions">добавить условие</button>-->
      <!--      <div class="mt-1">-->
      <!--        <div v-for="(opt, i) in taskData.options" class="input-group">-->
      <!--          <select v-model="opt.joinCondition" class="form-control">-->
      <!--            <option value="and">и</option>-->
      <!--            <option value="or">или</option>-->
      <!--          </select>-->
      <!--          <select v-model="opt.condition.field" class="form-control">-->
      <!--            <option value="call">спрос</option>-->
      <!--            <option value="price">цена</option>-->
      <!--            <option value="stores">наличие</option>-->
      <!--          </select>-->
      <!--          <select v-model="opt.condition.condition" class="form-control">-->
      <!--            <option value=">">></option>-->
      <!--            <option value="<"><</option>-->
      <!--            <option value="=">=</option>-->
      <!--          </select>-->
      <!--          <input type="number" placeholder="Число" v-model="opt.condition.value" class="form-control">-->
      <!--          <button class="btn btn-outline-danger" @click="removeOption(i)"><i class="icon-fa icon-fa-remove"/></button>-->
      <!--        </div>-->
      <!--      </div>-->
    </div>
    <div class="mt-1 flex justify-content-end">
      <LoadingButton
        title="Сохранить"
        :loading="loading"
        color="white"
        :onClick="() => saveTask()"
        className="btn btn-success"
      />
    </div>
  </div>
</template>

<script>

import LoadingButton from "@/components/buttons/LoadingButton.vue";
import api from "@/api";

export default {
  components: {LoadingButton},
  props: ['taskData', 'record003Id', 'getConditionTasks'],
  data() {
    return {
      loading: false,
      newOptionType: 1,
    }
  },
  created() {
    if (!this.taskData.type_id) {
      this.$set(this.taskData, 'type_id', -1);
      this.$set(this.taskData, 'options', []);
    }
  },
  methods: {
    validate() {
      if (+this.taskData.type_id === -2) {
        if (!this.taskData.options.length) {
          return {
            success: false,
            message: 'Не добавлены условия для черного списка'
          };
        }
        if (this.taskData.options.find((r) => !r.condition.value)) {
          return {
            success: false,
            message: 'Не указано число условия для черного списка'
          };
        }
      }
      return {success: true, data: this.taskData};
    },
    async saveTask() {
      let conditionData = {data: []};
      if (+this.taskData.type_id === -2) {
        conditionData = this.getConditionTasks();
        console.log(conditionData);
        if (!conditionData?.success) {
          toastr['warning'](conditionData?.message ?? 'ошибка условий', 'Неуспешно')
          return;
        }
        if (!(conditionData?.data ?? []).length) {
          toastr['warning']('нет условий', 'Неуспешно')
          return;
        }
      }
      this.loading = true;
      const {data} = await api.post('/tasks/stat/new', {
        tasks: {blackList: conditionData?.data ?? []},
        type: this.taskData.type_id,
        record_id: this.record003Id
      });
      if (data.success) {
        toastr['success']('Сохранено');
      } else {
        toastr['warning'](data?.message ?? 'ошибка сервера', 'Неуспешно')
      }
      this.loading = false;
    },
    removeOption(index) {
      delete this.taskData.options[index];
      this.taskData.options = this.taskData.options.filter((o) => o);
    },
    addOptions() {
      this.taskData.options.push({
        joinCondition: 'and',
        condition: {
          field: 'call',
          condition: '>',
          value: ''
        }
      });
    }
  }
}
</script>

<style scoped>

</style>
